import SuperRepository from '../superRepository'

export default new (class PostbacksRepository extends SuperRepository {
  baseUri() {
    return 'postback'
  }
  resendPostbacks = ({ signal, ...data }) => this.httpClient().post(this.baseUri() + '_export/resent_postbacks', data, { signal })
  exportPostbacksReportToken = (data, params) => this.reportHttpClient().postQuery('export/postback/token', data, params)
})()
